<mat-form-field class="form-field" [appearance]="appearance" [formGroup]="formGroup">
    
    <mat-label>
        {{label}}
    </mat-label>

    <input autocomplete="off" formControlName="filter" matInput [matAutocomplete]="autoComplete" #trigger="matAutocompleteTrigger" (focusout)="filterFocusout()" (keyup.enter)="takeFilterValue()" type="text" />

    <button mat-icon-button [disabled]="filterControl.errors" matSuffix color="primary" (click)="takeFilterValue()">
        <mat-icon>done</mat-icon>
    </button>

    <mat-autocomplete #autoComplete="matAutocomplete">

        <ng-container *ngFor="let address of eMailAddresses">
            <mat-option [value]="address" (click)="addAddress(address)">
                {{address}}
            </mat-option>
        </ng-container>

        <mat-option *ngIf="totalItems > eMailAddresses.length" (click)="loadMore($event)">
            Mehr laden
        </mat-option>

    </mat-autocomplete>
    
</mat-form-field>
